<template>

    <section class="full-width no-padding-top" id="credit-card-update">

        <div class="container">

            <div class="row heading">

                <div class="col-12">

                    <h1 class="h2">Update your payment details</h1>

                </div>

            </div>

            <div class="row">

                <div class="col-12 col-md-6">

                    <h3 class="h4"><i class="fal fa-credit-card-front"></i>Your saved card</h3>

                    <div class="card">

                        <div class="card-body">

                            <div v-cloak v-if="savedCard" class="card-text">

                                <div class="name" v-if="savedCard.name">Name on card: {{ savedCard.name }}</div>
                                <div class="number" v-if="savedCard.last4">Last four digits: {{ savedCard.last4 }}</div>
                                <div class="exp" v-if="savedCard.exp_year && savedCard.exp_month">Expiry: {{ savedCard.exp_month }}/{{ savedCard.exp_year }}</div>
                                <div class="brand" v-if="savedCard.brand">Card type: {{ savedCard.brand }}</div>

                            </div>

                            <div v-if="!savedCard" class="card-text">You don't appear to have a card saved at the moment</div>

                        </div>
                    </div>

                </div>

                <div class="col-12 col-md-6">

                    <h3 class="h4"><i class="fal fa-save"></i>Save new card</h3>

                    <input v-model="newName" name="newName" id="cardholder-name" type="text" placeholder="Your full name">

                    <div id="credit-card-stripe-element"></div>
                    <button :disabled="thinking" v-on:click="process" class="core-btn" id="card-button">Save Card</button>

                </div>

            </div>

        </div>

    </section>

</template>

<script>
    module.exports = {

        name: 'credit-card-update',

        data() {

            return {

                savedCard: pageData.credit_cards.length ? pageData.credit_cards[0] : false, //get the first in the list of credit cards
                newName: '',
                thinking: false,
                clientSecret: pageData.clientSecret,

            }

        },

        mounted() {

            //stripe
            this.elements = new LCStripe();
            this.cardElement = this.elements.createCard(),
            this.cardElement.mount('#credit-card-stripe-element');

            if(this.savedCard === 'false'){

                coreVariables.triggerModal('Slight issue', 'We cannot find any credit cards associated with your account please get in touch at support@lyndicohen.com');

            }
        },

        methods: {

            process() {

                this.thinking = true;

                stripe.createToken(this.cardElement, {

                    name: this.newName

                }).then(function(result) {

                    if (result.error) {

                        window.vueAccount.$refs.creditCard.thinking = false;

                        // creditCardUpdate.thinking = false;
                        coreVariables.triggerModal('Found an issue', result.error.message);

                    } else {

                        console.log('LC: card token success');

                        if (result.token.id) {

                            window.coreHelpers.ajax.call(this, 'POST', 'lc_update_card', {

                                'card_token': result.token

                            }, function(res) {

                                if (res.success) {

                                    this.thinking = false;
                                    window.vueAccount.$refs.creditCard.savedCard = res.data;
                                    coreVariables.triggerModal('Success', 'Your card has been updated');

                                } else {

                                    this.thinking = false;
                                    coreVariables.triggerModal('Issue found', 'There has been an issue updating your card, please try again later');

                                }

                            }, function(res) {

                                this.thinking = false;
                                coreVariables.triggerModal('Issue found', 'Something has gone wrong, please try again later');
                                console.log('error', res);

                            }, null, false);

                        }
                    }

                });

            }
        }

    };
</script>